import { BaseDto } from "@app/modules/shared/model/base.dto";
import { MaterialDto } from "@dashboard/modules/material-management/material/model/material.dto";
import { VirtualOrderDto } from "@dashboard/modules/shipping-management/virtual-order-receipt/model/virtual-order.dto";
import { CurrentAccountDto } from "@dashboard/modules/finance-management/current-account/model/current-account.dto";
import { CustomerDto } from "@dashboard/modules/shipping-management/customer/model/customer.dto";

export class ProductLicenseDto extends BaseDto {
  material: MaterialDto;
  license_key: string;
  main_license_key: string;
  installed: string;
  locked: string;
  user_count: number;
  terminal_id: string;
  virtualOrder: VirtualOrderDto;
  customer: CustomerDto;
  currentAccount: CurrentAccountDto;
  lock_reason: string;
  lem_end_date: number;
}
